import MyApp from "./MyApp";

function App() {
  return (
    <div className="App">
      <MyApp />
    </div>
  );
}

export default App;
